import { d as t } from "./document-create-element.js";
var o = t("span").classList,
  e = o && o.constructor && o.constructor.prototype,
  r = e === Object.prototype ? void 0 : e;
export { r as d };